import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { LoginGuard } from "../core/guards/login.guard";

import { PlacaComponent } from "./placa.component";
import { MailboxComponent } from "./mailbox/mailbox.component";
import { RequestComponent } from "./request/request.component";
import { QueryComponent } from "./query/query.component";
import { ListQueryComponent } from "../placa/query/list-query/list-query.component";
import { ListMailboxComponent } from "./mailbox/list-mailbox/list-mailbox.component";
import { DetailMailboxComponent } from "./mailbox/detail-mailbox/detail-mailbox.component";
import { PwdExpiratedGuard } from "../core/guards/pwdExpirated";
import { RequestPlacaReedicionSolicitudComponent } from "./request/request-placa-reedicion-solicitud/request-placa-reedicion-solicitud.component";
import { QueryFilesPlacaComponent } from "./query-files-placa/query-files-placa.component";
import { ClearFiltersGuard } from "../core/guards/clear-filters.guard";

const routesPlaca: Routes = [
  {
    path: "",
    component: PlacaComponent,
    canActivate: [LoginGuard, PwdExpiratedGuard],
    children: [
      {
        path: "buzon",
        component: MailboxComponent,
        children: [
          {
            path: "lista",
            component: ListMailboxComponent,
            canActivate: [ClearFiltersGuard],
          },
          {
            path: "detalle/:id",
            component: DetailMailboxComponent,
            data: {
              operation: "detail",
            },
          },
        ],
      },
      {
        path: "solicitud-placa",
        component: RequestComponent,
        children: [
          {
            path: "datos",
            component: RequestPlacaReedicionSolicitudComponent,
          },
        ],
      },
      {
        path: "consulta",
        component: QueryComponent,
        children: [
          {
            path: "lista",
            component: ListQueryComponent,
            canActivate: [ClearFiltersGuard],
          },
          {
            path: "detalle/:id",
            component: DetailMailboxComponent,
            data: {
              operation: "detail",
              type: "NotHistory",
              url: "consulta",
            },
          },
          {
            path: "detalle/historico/:id",
            component: DetailMailboxComponent,
            data: {
              operation: "detail",
              type: "history",
              url: "consulta",
            },
          },
        ],
      },
      {
        path: "consulta-ficheros-placa",
        component: QueryFilesPlacaComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routesPlaca)],
  exports: [RouterModule],
})
export class PlacaRoutingModule {}
